import {XhrService} from "../ts/xhr.service";
import {getAllQuantityInputs} from "./quantitySpinner";
import {updateItemlistStickyOrderBarCount} from "./itemlistStickyOrderBar";
import {addErrorClass, addLoadingClass, removeLoadingClass} from "./utilities/updateClasses";
import {Tooltip} from "./tooltip";

const SESSION_ID = document.body.dataset.sessionId;

function updateInputDirectorder(input) {
    let InputValue = input.value;
    XhrService.generalAjaxCall('getDirectOrderItemListRender', {
        "sid": SESSION_ID,
        "item_list": [InputValue]
    }, 'POST', 'json').then(response => {
        if (response) {
            removeLoadingClass(input.closest(".inputGroup"));
            const response_item_key = Object.keys(response);

            for (const item_no of response_item_key) {
                let itemElement = document.getElementById("activDirectOrder");
                if (itemElement) {
                    hideDirectOrderItemisConfigurableMessage();
                    if (response[item_no].show) {
                        hideDirectorderMessageMaximum();
                        hideDirectorderMessage();
                        if (response[item_no].image) {
                            itemElement.querySelector('.image img').setAttribute("src", response[item_no].image);
                        }
                        if (response[item_no].itemID) {
                            itemElement.querySelector('.input_item_id').setAttribute("value", response[item_no].itemID);
                            itemElement.querySelector('.input_item_id').setAttribute("name", 'input_item_id_' + response[item_no].next_key);
                        }
                        if (response[item_no].price) {
                            itemElement.querySelector('.js-include-prices').innerHTML = response[item_no].price;
                        }
                        if (response[item_no].inventory) {
                            itemElement.querySelector('.js-include-inventory').innerHTML = response[item_no].inventory;
                        }
                        if (response[item_no].orderbutton) {
                            itemElement.querySelector('.js-include-addon').innerHTML = response[item_no].orderbutton;
                        }

                        const warningTooltip = response[item_no].warningTooltip ? response[item_no].warningTooltip : '';
                        itemElement.querySelector('.directOrderItemlistItem__info').innerHTML = `<small class="directOrderItemlistItem__itemNo">${item_no}</small>&nbsp;${warningTooltip}<br/><a href="${response[item_no].item_link}" class="directOrderItemlistItem__description">${response[item_no].description}</a><small>${response[item_no].additionalShippingCost}</small>`;
                        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));

                      tooltipTriggerList.map(function (tooltipTriggerEl) {
                            return new Tooltip(tooltipTriggerEl,{html:true});
                        });
                        window.scrollTo({
                            top: document.getElementById('activDirectOrder').getBoundingClientRect().top + window.pageYOffset - document.getElementById('header').offsetHeight,
                            behavior: "smooth"
                        });

                        if (response[item_no].emptybox) {
                            itemElement.insertAdjacentHTML(
                                'afterend',
                                response[item_no].emptybox
                            );
                        }

                        itemElement.classList.remove("directOrderItemlistItem--empty");
                        itemElement.setAttribute("id", "");
                        const directOrderInputSubmit = document.getElementById('item_no_input_direct_order');
                        directOrderInputSubmit.addEventListener('keyup', function (ItemInputEvent) {
                            var InputValue = directOrderInputSubmit.value;
                            if (InputValue.length > 0) {
                                if (ItemInputEvent.key === "Enter") {
                                    ItemInputEvent.preventDefault();
                                    ItemInputEvent.stopPropagation();
                                    ItemInputEvent.stopImmediatePropagation();

                                    enterSubmitInput(directOrderInputSubmit);
                                }
                            }
                        });
                        const directOrderInputSubmitButton = document.getElementById('js-direct-order-submit-button')

                        if (directOrderInputSubmitButton) {
                            directOrderInputSubmitButton.addEventListener('click', function (e) {
                                var InputValue = directOrderInputSubmit.value;
                                if (InputValue.length > 0) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    e.stopImmediatePropagation();
                                    enterSubmitInput(directOrderInputSubmit);
                                }
                            });
                        }
                        if (!response[item_no].show) {
                            document.getElementById('item_no_input_direct_order').focus();

                        } else {
                            if (!response[item_no].available) {
                                itemElement.querySelector('.js_quantity_input').disabled = true;
                                itemElement.querySelector('.quantity').classList.add("quantity--inactive");
                            }
                            itemElement.querySelector('.js_quantity_input').focus();
                            itemElement.querySelector('.js_quantity_input').select();
                        }
                        document.getElementById('item_no_input_direct_order').focus();

                    }
                    else if(response[item_no].is_configurable){
                        showDirectOrderItemIsConfigurableMessage(response[item_no].is_configurable);
                    }
                    else {
                        showDirectorderMessage();
                    }
                }
            }

            updateItemlistStickyOrderBarCount();
            setNewTabindexes();
        }
    }).catch(function (err) {
        console.error(err);
        addErrorClass(input.closest(".inputGroup"));
    });
}

function enterSubmitInput(input) {
    hideDirectorderMessageMaximum();
    hideDirectorderMessage();
    addLoadingClass(input.closest(".inputGroup"));

    if (document.querySelectorAll('.directOrderItemlistItem').length >= 500) {
        showDirectorderMessageMaximum();
    } else {
        updateInputDirectorder(input);
    }
}

function hideDirectorderMessage() {
    const directOrderMessageMaximum = document.getElementById("directOrderMessage");
    if (directOrderMessageMaximum) {
        directOrderMessageMaximum.classList.add("hidden");
    }
}

function showDirectorderMessage() {
    const directOrderMessageMaximum = document.getElementById("directOrderMessage");
    if (directOrderMessageMaximum) {
        directOrderMessageMaximum.classList.remove("hidden");
    }
}

function showDirectOrderItemIsConfigurableMessage(text){
    const directOrderMessage = document.getElementById("directOrderMessageConfigurableText");
    if(directOrderMessage){
        directOrderMessage.innerHTML = text;
    }

    const directOrderHeader = document.getElementById("directOrderMessageConfigurable");
    if (directOrderHeader) {
        directOrderHeader.classList.remove("hidden");
    }
}

function hideDirectOrderItemisConfigurableMessage() {
    const directOrderMessage = document.getElementById("directOrderMessageConfigurableText");
    if (directOrderMessage) {
        directOrderMessage.innerHTML = '';
    }

    const directOrderHeader = document.getElementById("directOrderMessageConfigurable");
    if (directOrderHeader) {
        directOrderHeader.classList.add("hidden");
    }
}

function hideDirectorderMessageMaximum() {
    const directOrderMessageMaximum = document.getElementById("directOrderMessageMaximum");
    if (directOrderMessageMaximum) {
        directOrderMessageMaximum.classList.add("hidden");
    }
}

function showDirectorderMessageMaximum() {
    const directOrderMessageMaximum = document.getElementById("directOrderMessageMaximum");
    if (directOrderMessageMaximum) {
        directOrderMessageMaximum.classList.remove("hidden");
    }
}

function resetDirectOrder() {
    hideDirectorderMessageMaximum();
    for (let item of document.querySelectorAll('.directOrderItemlistItem:not(.directOrderItemlistItem--empty):not(.directOrderItemlistItem--header)')) {
        item.remove();
    }
    const activDirectOrder = document.getElementById("activDirectOrder");
    if (activDirectOrder) {
        activDirectOrder.setAttribute("data-id-row", 0);
    }
    updateItemlistStickyOrderBarCount();
}

function removeAllAction() {
    resetDirectOrder();
    XhrService.generalAjaxCall('deleteAllDirectOrderItemListItem', {
        "sid": SESSION_ID,
    }, 'POST', 'json').then(response => {
        if (response) {
        }
    });
}

function removeFromDirectOrderAction(target) {
    hideDirectorderMessageMaximum();
    let deleteRow = target.closest(".directOrderItemlistItem");
    XhrService.generalAjaxCall('deleteDirectOrderItemListItem', {
        "sid": SESSION_ID,
        "item_list": [deleteRow.getAttribute("data-id-row")]
    }, 'POST', 'json').then(response => {
        if (response) {
            const response_item_key = Object.keys(response);
            for (const item_no of response_item_key) {
                if (response[item_no].action) {
                    deleteRow.remove();
                    let rows = document.querySelectorAll('.directOrderItemlistItem:not(.directOrderItemlistItem--empty):not(.directOrderItemlistItem--header)');
                    if (rows.length === 0) {
                        resetDirectOrder();
                    }
                    updateItemlistStickyOrderBarCount();
                }
            }
        }
    });
}

function setNewTabindexes() {
    let count = 10000;
    let qtyInputs = getAllQuantityInputs(document.querySelector(".directOrderList"));
    const directOrderInputSubmit = document.getElementById('item_no_input_direct_order');

    if (qtyInputs) {
        for (let quantityInput of qtyInputs) {
            quantityInput.tabIndex = count;
            count++;
        }
    }

    if (directOrderInputSubmit) {
        directOrderInputSubmit.tabIndex = count + 1;
    }
}

export function changeQuantityDirectOrder(id, value, counter) {
    XhrService.generalAjaxCall('changeQuantityDirectOrder', {
        "sid": SESSION_ID,
        "qty": parseInt(value),
        "counter": parseInt(counter),
    }, 'POST', 'json').then(response => {
        if (response) {
            //nix
        }
    });
}

export function initDirectOrder() {
    const directOrderForm = document.getElementById('quick_order_list_form'),
        directOrderInputSubmit = document.getElementById('item_no_input_direct_order'),
        directOrderInputSubmitButton = document.getElementById('js-direct-order-submit-button');

    if (!directOrderForm) {
        return;
    }
    if (!directOrderInputSubmit) {
        return;
    }

    function focusOnInput() {
        directOrderInputSubmit.focus();
    }

    focusOnInput();

    directOrderForm.addEventListener('submit', function (FormSubmitEvent) {
        FormSubmitEvent.preventDefault();
        FormSubmitEvent.stopPropagation();
        FormSubmitEvent.stopImmediatePropagation();
        if (directOrderInputSubmit.value === '') {
            focusOnInput();
        }
    });

    directOrderInputSubmit.addEventListener('keyup', function (ItemInputEvent) {
        var InputValue = directOrderInputSubmit.value;
        if (InputValue.length > 0) {
            if (ItemInputEvent.key === "Enter") {
                ItemInputEvent.preventDefault();
                ItemInputEvent.stopPropagation();
                ItemInputEvent.stopImmediatePropagation();

                enterSubmitInput(directOrderInputSubmit);
            }
        }
    });

    if (directOrderInputSubmitButton) {
        directOrderInputSubmitButton.addEventListener('click', function (e) {
            var InputValue = directOrderInputSubmit.value;
            if (InputValue.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                enterSubmitInput(directOrderInputSubmit);
            }
        });
    }

    document.querySelector('.js-addListItemToBasketAll').addEventListener('click', function () {
        setTimeout(function () {
            removeAllAction();
            focusOnInput();
        }, 200);
    });

    document.addEventListener("click", function (e) {
        if (e.target.classList.contains("js-removeFromDirectOrder")) {
            removeFromDirectOrderAction(e.target);
        }
    });
}